import { IntlShape } from "react-intl";
import { IPlan } from "../types";

export default (description: IPlan["description"], intl: Partial<IntlShape>) => {
    const { locale } = intl;
    if (!description) return "";
    if (description[locale!]) return description[locale!];
    if (description.en) return description.en;
    if (Object.keys(description).length === 0) return "";
    return description[Object.keys(description)[0]];
};
